// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1k53B","savePackageButton":"ClientWallet_savePackageButton__3KzfM"};